import React from "react";

const DvsVerified = ({ className = "" }) => {
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 bg-[#46DA55] bg-opacity-10 border border-[#46DA55] rounded-full whitespace-nowrap flex-shrink-0 ${className}`}>
      <svg 
        className="w-3 h-3 text-[#46DA55] flex-shrink-0" 
        fill="currentColor" 
        viewBox="0 0 20 20"
      >
        <path 
          fillRule="evenodd" 
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" 
          clipRule="evenodd"
        />
      </svg>
      <span className="text-[10px] font-semibold text-[#46DA55] uppercase tracking-wide">DVS Verified</span>
    </span>
  );
};

export default DvsVerified;
